import React, { useState, useEffect } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';
import { BASE_URL,CHAT_IDS,Rigi_CHAT_IDS, Rigi_CHAT_NAME, getRkbAppToken } from "../../utils/config";
import Loading from "../loading";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Tooltip from '@mui/material/Tooltip';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import Switch from "@mui/material/Switch";
import RefreshIcon from '@mui/icons-material/Refresh';
import SendIcon from '@mui/icons-material/Send';
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useNavigate } from 'react-router-dom';
const ScreenerTab = (props) => {
  
  const navigate = useNavigate();
  const columns = [
    { id: "Remove", label: "Remove", minWidth: 40 },
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: 'SignalType', label: 'Stock Name', minWidth: 120 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },
    { id: 'PriceAtSignal', label: 'PriceAtSignal', minWidth: 90 },
    { id: 'Current_cmp', label: 'CurrentCMP', minWidth: 110 },
    { id: 'prv_day_close', label: '1 Day P/L', minWidth: 110 },
    { id: 'SignalStopLoss', label: 'SignalStopLoss', minWidth: 70 },
    { id: 'Margin', label: 'Margin', minWidth: 70 },
    { id: 'FirstTarget', label: 'First Target', minWidth: 90 },
    { id: 'SignalFinal', label: 'SignalFinal', minWidth: 100 },
    { id: 'lot_size', label: 'LotSize', minWidth: 80 },
    { id: 'OptionAtMoney', label: 'StrikePrice', minWidth: 80 },
    { id: 'HighAfterSignal', label: 'HA Signal', minWidth: 70 },
    { id: 'LowAfterSignal', label: 'LA Signal', minWidth: 90 },
    { id: 'Expiry', label: 'Expiry', minWidth: 110 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'volume', label: 'Volume', minWidth: 80 },
    { id: 'HighDT', label: 'HighDT', minWidth: 110 },
    { id: 'LowDT', label: 'LowDT', minWidth: 110 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'close', label: 'Close', minWidth: 70 },
    { id: 'open', label: 'Open', minWidth: 70 },
    { id: 'high', label: 'High', minWidth: 70 },
    { id: 'low', label: 'Low', minWidth: 70 },
    { id: 'InstrumentToken', label: 'Ins Token', minWidth: 100 },
    { id: 'ExchangeToken', label: 'Exc Token', minWidth: 100 },
    { id: 'IndexStopLoss', label: 'IndexStopLoss', minWidth: 80 },
    { id: 'close_sma12', label: 'C_sma12', minWidth: 90 },
    { id: 'close_sma26', label: 'C_sma26', minWidth: 90 },
    { id: 'close_sma200', label: 'C_sma200', minWidth: 90 },
  ];

  const Intradaycolumns = [
    { id: "Remove", label: "Remove", minWidth: 40 },
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: 'SignalType', label: 'Stock Name', minWidth: 120 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },
    { id: 'PriceAtSignal', label: 'PriceAtSignal', minWidth: 90 },
    { id: 'Current_cmp', label: 'CurrentCMP', minWidth: 110 },
    { id: 'prv_day_close', label: '1 Day P/L', minWidth: 110 },
    { id: 'SignalStopLoss', label: 'SignalStopLoss', minWidth: 70 },
    { id: 'FirstTarget', label: 'First Target', minWidth: 90 },
    { id: 'SignalFinal', label: 'SignalFinal', minWidth: 100 },
    { id: 'lot_size', label: 'LotSize', minWidth: 80 },
    { id: 'OptionAtMoney', label: 'StrikePrice', minWidth: 80 },
    { id: 'HighAfterSignal', label: 'HA Signal', minWidth: 70 },
    { id: 'LowAfterSignal', label: 'LA Signal', minWidth: 90 },
    { id: 'Expiry', label: 'Expiry', minWidth: 110 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'volume', label: 'Volume', minWidth: 80 },
    { id: 'HighDT', label: 'HighDT', minWidth: 110 },
    { id: 'LowDT', label: 'LowDT', minWidth: 110 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'close', label: 'Close', minWidth: 70 },
    { id: 'open', label: 'Open', minWidth: 70 },
    { id: 'high', label: 'High', minWidth: 70 },
    { id: 'low', label: 'Low', minWidth: 70 },
    { id: 'InstrumentToken', label: 'Ins Token', minWidth: 100 },
    { id: 'ExchangeToken', label: 'Exc Token', minWidth: 100 },
    { id: 'IndexStopLoss', label: 'IndexStopLoss', minWidth: 80 },
    { id: 'close_sma12', label: 'C_sma12', minWidth: 90 },
    { id: 'close_sma26', label: 'C_sma26', minWidth: 90 },
    { id: 'close_sma200', label: 'C_sma200', minWidth: 90 },
  ];

  const Scriptcolumns = [
    { id: "Remove", label: "Action", minWidth: 120 },
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: 'SignalType', label: 'Stock Name', minWidth: 120 },
    { id: 'Interval_Time', label: 'Interval Time', minWidth: 120 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'PriceAtSignal', label: 'PriceAtSignal', minWidth: 90 },
    { id: 'Current_cmp', label: 'CurrentCMP', minWidth: 110 },
    { id: 'SignalStopLoss', label: 'SignalStopLoss', minWidth: 70 },
    { id: 'lot_size', label: 'LotSize', minWidth: 80 },
    { id: 'SignalFinal', label: 'SignalFinal', minWidth: 100 },
    { id: 'OptionAtMoney', label: 'StrikePrice', minWidth: 80 },
    { id: 'validation_remarks', label: 'V Remarks', minWidth: 150 },
    { id: 'HighAfterSignal', label: 'HA Signal', minWidth: 70 },
    { id: 'HighDT', label: 'HighDT', minWidth: 110 },
    { id: 'LowAfterSignal', label: 'LA Signal', minWidth: 90 },
    { id: 'LowDT', label: 'LowDT', minWidth: 110 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'close', label: 'Close', minWidth: 70 },
    { id: 'open', label: 'Open', minWidth: 70 },
    { id: 'high', label: 'High', minWidth: 70 },
    { id: 'low', label: 'Low', minWidth: 70 },
    { id: 'volume', label: 'Volume', minWidth: 80 },
    { id: 'Expiry', label: 'Expiry', minWidth: 110 },
    { id: 'InstrumentToken', label: 'Ins Token', minWidth: 100 },

  ];

  const PreviousColumns = [

    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: "Action", label: "Action", minWidth: 70},
    { id: 'SignalType', label: 'Stock Name', minWidth: 120 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },  
    { id: 'PriceAtSignal', label: 'PriceAtSignal', minWidth: 90 },
    { id: 'PriceAtExit', label: 'P/L', minWidth: 110 },
    { id: 'ExitDt', label: 'ExitDt', minWidth: 110 },
    { id: 'FirstTarget', label: 'First Target', minWidth: 90 },
    { id: 'SignalStopLoss', label: 'SignalStopLoss', minWidth: 70 },
    { id: 'HighAfterSignal', label: 'HA Signal', minWidth: 70 },
    { id: 'LowAfterSignal', label: 'LA Signal', minWidth: 90 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'volume', label: 'Volume', minWidth: 80 },
    { id: 'Expiry', label: 'Expiry', minWidth: 110 },
    { id: 'lot_size', label: 'LotSize', minWidth: 80 },
    { id: 'SignalFinal', label: 'SignalFinal', minWidth: 100 },
    { id: 'OptionAtMoney', label: 'StrikePrice', minWidth: 80 },
    { id: 'HighDT', label: 'HighDT', minWidth: 110 },
    { id: 'LowDT', label: 'LowDT', minWidth: 110 },
    { id: 'SLTrigger', label: 'SLTrigger', minWidth: 50 },
    { id: 'SLTriggerDT', label: 'SLTriggerDT', minWidth: 130 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'close', label: 'Close', minWidth: 70 },
    { id: 'open', label: 'Open', minWidth: 70 },
    { id: 'high', label: 'High', minWidth: 70 },
    { id: 'low', label: 'Low', minWidth: 70 },
    { id: 'InstrumentToken', label: 'Ins Token', minWidth: 100 },
  ];
  const Record = props.Record
  const heading = props.heading
  const updateSLchange = props.updateSLchange
  const RecordColor = props.RecordColor
  const PreviousRecord = props.PreviousClose
  console.log(`Record for ${heading}`)
  let AutomateRecord = props.heading === 'Option Tab' ? props.AutomateRecord : []
  const [authdata, setAuthData] = useState({
    username: '',
    password: ''
  });
  const [cmp, setCMP] = useState('')
  const [stockPrice, setStockPrice] = useState('');
  const [futurePrice, setFuturePrice] = useState('');
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [checked, setChecked] = useState(true);
  const [DelSelectedRecord, setDelSelectedRecord] = useState({});
  const [authenticationOpen, setAuthenticationOpen] = useState(false);
  const [SLEditOpen, setSLEditOpen] = useState(false);
  const [FirstTargetEditOpen, setFirstTargetEditOpen] = useState(false);
  const [SecondTargetEditOpen, setSecondTargetEditOpen] = useState(false);
  const [RemoveAlert, SetRemoveAlert] = useState(false);
  const [AutomateRemoveAlert, SetAutomateRemoveAlert] = useState(false);
  const [BookPorL, setBookPorL] = useState('')
  const [newsl, setNewSL] = useState('');
  const [newfirstTarget, setNewFirstTarget] = useState('');
  const [newsecondTarget, setNewSecondTarget] = useState('');
  const [showInvalidPasswordAlert, setShowInvalidPasswordAlert] =
    useState(false);
  const [Errorshow, setErrorShow] = useState(false);
  const [Errormessage, setErrorMessage] = useState('');

  const [screenerOldData, setScreenerOldData] = useState([]);
  const [futureOldData, setFutureOldData] = useState([]);
  const [optionOldData, setOptionOldData] = useState([]);
  const [AutomateOldData, setAutomateOldData] = useState([]);
  const [IntraDayOldData, setIntraDayOldData] = useState([]);
  const [deliveryOldData, setDeliveryOldData] = useState([]);
  const [hniOldData, setHniOldData] = useState([]);
  const [newRecords, setNewRecords] = useState([]);
  const [AutomatenewRecords, setAutomateNewRecords] = useState([]);
  const [AlertMessage, setAlertMessage] = useState("");
  const [showAlert, setshowAlert] = useState(false);
  const [RefreshAutomateData, setRefreshAutomateData] = useState()
  const [commentrymessage, setCommentryMessage] = useState()
  const [automateRemark, setAutomateRemark] = useState(false);
  const [selectedAutomateRecord, setSelectedAutomateRecord] = useState(false);
  const TELEGRAM_API_TOKEN ='6848586856:AAE_JEYn2MH2j16n0fYD-1V9adL0QDknS7I';
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+[\]{};:<>?]{8,}$/;

  const [MessageSLandFirstTraget,setMessageSLandFirstTraget]=useState(false);
  const [SlandFirstTargetmsg,setSlandFirstTargetmsg]=useState("");

  useEffect(() => {
    try {
      console.log("inserting new record", Record.length);
      console.log("inserting new record", Record);
      if (heading === 'Screener Tab') {
      if (Record.length > 0) {
        const newRecord = Record.filter(record => !screenerOldData.some(d => d.id === record.id));
        console.log("newRecords", newRecord);
        setNewRecords(newRecord);
        setScreenerOldData(Record);
        // if (newRecord.length > 0) {
        // // alert(`${newRecord.length} new records added to Screener Tab.`);
        // }
      }
      }
      if (heading === 'Future Tab') {
      if (Record.length > 0) {
        const newRecord = Record.filter(record => !futureOldData.some(d => d.id === record.id));
        console.log("newRecords", newRecord);
        setNewRecords(newRecord);
        setFutureOldData(Record);
      
      }
      }
      if (heading === 'Option Tab') {
      if (Record.length > 0) {
        const newRecord = Record.filter(record => !optionOldData.some(d => d.id === record.id));
        console.log("newRecords", newRecord);
        setNewRecords(newRecord);
        setOptionOldData(Record);
        // if (newRecord.length > 0) {
        // alert(`${newRecord.length} new records added to Option Tab.`);
        // }
      }
      if (AutomateRecord.length > 0) {
        const newRecord = AutomateRecord.filter(record => !AutomateOldData.some(d => d.id === record.id));
        console.log("newRecords", newRecord);
        setAutomateNewRecords(newRecord);
        setAutomateOldData(AutomateRecord);
        // if (newRecord.length > 0) {
        // alert(`${newRecord.length} new records added to Automate Records.`);
        // }
      }
      }
      if (heading === 'IntraDay Tab') {
      if (Record.length > 0) {
        const newRecord = Record.filter(record => !IntraDayOldData.some(d => d.id === record.id));
        console.log("newRecords", newRecord);
        setNewRecords(newRecord);
        setIntraDayOldData(Record);
        // if (newRecord.length > 0) {
        // alert(`${newRecord.length} new records added to IntraDay Tab.`);
        // }
      }
      }
      if (heading === 'Delivery Tab') {
      if (Record.length > 0) {
        const newRecord = Record.filter(record => !deliveryOldData.some(d => d.id === record.id));
        console.log("newRecords", newRecord);
        setNewRecords(newRecord);
        setDeliveryOldData(Record);
        // if (newRecord.length > 0) {
        // alert(`${newRecord.length} new records added to Delivery Tab.`);
        // }
      }
      }
      if (heading === 'HNI Tab') {
      if (Record.length > 0) {
        const newRecord = Record.filter(record => !hniOldData.some(d => d.id === record.id));
        console.log("newRecords", newRecord);
        setNewRecords(newRecord);
        setHniOldData(Record);
        // if (newRecord.length > 0) {
        // alert(`${newRecord.length} new records added to HNI Tab.`);
        // }
      }
      }
    } catch (error) {
      console.error("Error in useEffect for handling records:", error);
      setAlertMessage("An error occurred while processing records. Please check the console for details.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
      
    }
  }, [Record]);

  // handle close Dialog book profit or loss
  const handleClose = () => {
    setCommentryMessage('');
    setOpenDialog(false);
    setChecked(true)
  };


  // handle change page and rows per page

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex = newPage * rowsPerPage;
    console.log("startindex", startindex)
    let endindex = Math.min(startindex + rowsPerPage, Record.length)
    console.log("endindex", endindex)
    setStartIndex(startindex);
    setEndIndex(endindex)

  };

  // handle change rows per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };

  // handle format date and time
  const formatDateTime = (row) => {

    // console.log("row.datetime",row.datetime)

    let date = new Date(row.datetime);
    // console.log("timeDate",date)
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    // Format the date and time
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

    //  console.log(formattedDate);
    return formattedDate
  }

// handle format date and time for exitDt
  const formatExitDt = (row) => {
    let date = new Date(row.ExitDt);
  
    // Format the date and time in IST timezone
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Kolkata',
      hour12: false 
    };
    
    const formattedDate = date.toLocaleString('en-IN', options)
    .replace(',', '')
    .replace(/\//g, '-');
  
    return formattedDate;
  };

  // handle format date and time for expiry
  const formatExpiry = (row) => {



    let date = new Date(row.Expiry);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // Format the date and time
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

    //  console.log(formattedDate);
    return formattedDate
  }

  //    render Active div  in table
  const ActionDiv = (row)=>{
    
    return(
      <div style={{display:"flex",flexDirection:'row',justifyContent:'space-around'}}>
       <Tooltip title={"SL Trigger Close"} placement="right">
        <SendIcon sx={{ width: 20, height: 20 }} onClick={()=>{handleSLMesageSend(row)}} />
      </Tooltip>
      <Tooltip title={"First Target Close"} placement="right">
        <TrackChangesIcon sx={{ width: 20, height: 20 }} onClick={()=>{handleFirstMesageSend(row)}} />
      </Tooltip>
      </div>
    )
  }

// prepare sl Trigger message
  const handleSLMesageSend = (row) => {
    try {
      setSelectedRecord(row);
      let message = `SL of ${row.SignalType} is Triggered.\nPosition Closed.`;
      setMessageSLandFirstTraget(true);
      setSlandFirstTargetmsg(message);
    } catch (error) {
      console.error("Error in handleSLMesageSend:", error);
      setAlertMessage("An error occurred while preparing the SL message.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
      
    }
  };

  // prepare first target message
  const handleFirstMesageSend = (row) => {
    try {
      setSelectedRecord(row);
      let message = `Dear Traders,\n${row.SignalType} Target Achieved i.e., ${row.FirstTarget}`;
      setMessageSLandFirstTraget(true);
      setSlandFirstTargetmsg(message);
    } catch (error) {
      console.error("Error in handleFirstMesageSend:", error);
      setAlertMessage("An error occurred while preparing the First Target message.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };


  // handle close message dialog for sl and first target
  const handleSLandFirstTragetClose = ()=>{
    setMessageSLandFirstTraget(false);
    setSlandFirstTargetmsg("");
   
  }



// function handle send to telegram message
  const SLandFirstSendToTelegram = async () => {
    setLoading(true);

    try {
      let messageSendResult = null;
      let chatId;
      let RigichatId;
      let Rigichatname;

      if (selectedRecord.SignalFinal === 'BUY FUT' || selectedRecord.SignalFinal === 'SELL FUT') {
        chatId = CHAT_IDS['Future'];
        RigichatId = Rigi_CHAT_IDS['Future'];
        Rigichatname = Rigi_CHAT_NAME['Future'];
      } else if (selectedRecord.SignalFinal === 'BUY CALL' || selectedRecord.SignalFinal === 'BUY PUT') {
        chatId = CHAT_IDS['Options'];
        RigichatId = Rigi_CHAT_IDS['Options'];
        Rigichatname = Rigi_CHAT_NAME['Options'];
      } else if (selectedRecord.SignalFinal === 'BUY CALL IntraDay' || selectedRecord.SignalFinal === 'BUY PUT IntraDay' || selectedRecord.SignalFinal === 'BUY IntraDay') {
        chatId = CHAT_IDS['IntraDay'];
        RigichatId = Rigi_CHAT_IDS['IntraDay'];
        Rigichatname = Rigi_CHAT_NAME['IntraDay'];
      } else if (selectedRecord.SignalFinal === 'BUY Delivery') {
        chatId = CHAT_IDS['Delivery'];
        RigichatId = Rigi_CHAT_IDS['Delivery'];
        Rigichatname = Rigi_CHAT_NAME['Delivery'];
      } else if (selectedRecord.SignalFinal === 'BUY HNI') {
        chatId = CHAT_IDS['HNI'];
        Rigichatname = Rigi_CHAT_NAME['HNI'];
      } else {
        throw new Error("Invalid SignalFinal type. Unable to determine chat IDs.");
      }

      if (!SlandFirstTargetmsg) {
        throw new Error("Message content is empty. Please provide a valid message.");
      }
      if (!RigichatId || !chatId || !SlandFirstTargetmsg) {
        throw new Error("Required data is missing. Please ensure RigichatId, chatId, and SlandFirstTargetmsg are provided.");
      }

       const params2 = {
          content: SlandFirstTargetmsg,
          attachments: "",
          type: "normal",
          notification_title: Rigichatname,
          description: SlandFirstTargetmsg,
          soundName: "tone4",
          notificationToneName: "Tone4",
          groupId: RigichatId,
          textColor: "#ffd",
          sendToTelegram: 0,
          bgColor: "#000"
        };

        const body2 = JSON.stringify(params2);

        const rkbAppToken = await getRkbAppToken();

        const rigiResponse = await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${rkbAppToken}`
          },
          body: body2,
        });

      if (!rigiResponse.ok) {
        throw new Error(`Failed to send message to Rigi. Status: ${rigiResponse.status}`);
      }


      const telegramResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          chat_id: chatId,
          text: SlandFirstTargetmsg,
        }),
      });

      if (!telegramResponse.ok) {
        throw new Error(`Failed to send message to Telegram. Status: ${telegramResponse.status}`);
      }

      messageSendResult = await telegramResponse.json();
      console.log("Message sent successfully:", messageSendResult);

      setAlertMessage("Message sent successfully.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);

    } catch (error) {
      console.error('Error sending to Telegram:', error);
      setAlertMessage(`Error: ${error.message}`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    } finally {
      setLoading(false);
      setSlandFirstTargetmsg("");
      setSelectedRecord({});
      setMessageSLandFirstTraget(false);
    }
  };
  

// function handle to get cmp for book profit or loss
  const hyperLinkStockName = async (row) => {
    try {
      console.log("rowData", row);
      setSelectedRecord(row);
      setLoading(true);
      let url;

      if (row.SignalFinal === 'BUY CALL IntraDay' || row.SignalFinal === 'BUY PUT IntraDay') {
        if (row.InstrumentToken && row.Stock_InsToken && row.future_token) {
          url = `${BASE_URL}/getcmpdashboard/${row.InstrumentToken}/${row.Stock_InsToken}/${row.future_token}`;
        } else {
          setAlertMessage("Error: Missing required data for IntraDay CMP fetch.");
          setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
          return;
        }
      }else if(row.SignalFinal === 'BUY HNI' || row.SignalFinal === 'BUY Delivery' ) {
        if (row.InstrumentToken) {
          url = `${BASE_URL}/getcmpdashboard/${row.InstrumentToken}/${row.InstrumentToken}/futureToken`;
        } else {
          setAlertMessage("Error: Missing required data for CMP fetch.");
          setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
          return;
        }
      } else {
        if (row.InstrumentToken && row.Stock_InsToken) {
          url = `${BASE_URL}/getcmpdashboard/${row.InstrumentToken}/${row.Stock_InsToken}/futureToken`;
        } else if(row.InstrumentToken){
          url = `${BASE_URL}/getcmpdashboard/${row.InstrumentToken}/Stock_InsToken/futureToken`;
        }
        else {
          setAlertMessage("Error: Missing required data for CMP fetch.");
          setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
          return;
        }
      }

      const response = await fetch(url, { method: "GET" });
      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();
      console.log("res", res);

      if (res.success) {
        console.log("auth pass");
        if (row.SignalFinal === 'BUY CALL IntraDay' || row.SignalFinal === 'BUY PUT IntraDay') {
          setCMP(res.data);
          setStockPrice(res.FuturePrice);
          setFuturePrice(res.StockPrice);
        } else {
          setCMP(res.data);
          setStockPrice(res.StockPrice);
          setFuturePrice(res.FuturePrice);
        }

        let value;
        if (row.SignalFinal === 'SELL FUT') {
          value = row.PriceAtSignal - res.data;
          value = value.toFixed(2);
        } else {
          value = res.data - row.PriceAtSignal;
          value = value.toFixed(2);
        }

        setBookPorL(value);
        console.log("print bookPorL", BookPorL);
        setOpenDialog(true);
      } else {
        console.error("CMP not found.");
        setAlertMessage("CMP not found. Please try again later.");
        setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
      }
    } catch (error) {
      console.error("Error in hyperLinkStockName:", error);
      setAlertMessage("An error occurred while fetching data. Please check the console for details.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    } finally {
      setLoading(false);
    }
  };

  // handle stock loss change
  const handleStockLossChange = (row) => {
    try {
      // console.log("row Data", row, typeof(row));
      if (row.SignalStopLoss === undefined ) {
        throw new Error("Invalid row data or missing SignalStopLoss.");
      }
      setSelectedRecord(row);
      setNewSL(row.SignalStopLoss);
      setAuthenticationOpen(true);
    } catch (error) {
      console.error("Error in handleStockLossChange:", error);
      setAlertMessage("An error occurred while processing the stock loss change. Please check the console for details.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle first target change
  const handleFirstTargetChangelink = (row) => {
    try {
      console.log("row Data", row);
      if (row.FirstTarget === undefined) {
        throw new Error("Invalid row data or missing FirstTarget.");
      }
      setSelectedRecord(row);
      setNewFirstTarget(row.FirstTarget);
      setFirstTargetEditOpen(true);
    } catch (error) {
      console.error("Error in handleFirstTargetChangelink:", error);
      setAlertMessage("An error occurred while processing the First Target change. Please check the console for details.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle second target change
  const handleSecondTargetChangelink = (row) => {
    try {
      console.log("row Data", row);
      if (row.SecondTarget === undefined ) {
        throw new Error("Invalid row data or missing SecondTarget.");
      }
      setSelectedRecord(row);
      setNewSecondTarget(row.SecondTarget);
      setSecondTargetEditOpen(true);
    } catch (error) {
      console.error("Error in handleSecondTargetChangelink:", error);
      setAlertMessage("An error occurred while processing the Second Target change. Please check the console for details.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle authentication close
  const handleAuthenticationClose = () => {
    setAuthData({
      username: '',
      password: ''
    })
    setAuthenticationOpen(false)
  }

  // handle sl edit close
  const handleSLEditClose = () => {
    setSLEditOpen(false)
  }

  // handle first target edit close
  const handleFirstTargetEditClose = () => {
    setFirstTargetEditOpen(false)
  }
  // handle second target edit close
  const handleSecondTargetEditClose = () => {
    setSecondTargetEditOpen(false)
  }

  // handle authentication submit
  const handleAuthSubmit = (e) => {
    e.preventDefault();
    console.log("inside auth handler");

    if (!authdata.username || !authdata.password) {
      setAlertMessage("Username and password are required.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
      return;
    }

    if (!passwordRegex.test(authdata.password)) {
      setShowInvalidPasswordAlert(true);
      setTimeout(() => {
        setShowInvalidPasswordAlert(false);
      }, 2000);
      return;
    }

    setLoading(true);

    try {
      let body = JSON.stringify({ AuthDetails: authdata });
      fetch(`${BASE_URL}/authsledit`, {
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
            console.log("auth pass");
            setLoading(false);
            setAuthData({
              username: '',
              password: ''
            });
            setAuthenticationOpen(false);
            setSLEditOpen(true);
          } else {
            setLoading(false);
            setAlertMessage(res.message || "Authentication failed.");
            setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error during authentication:", error);
          setLoading(false);
          setAlertMessage("An error occurred during authentication. Please try again.");
          setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
        });
    } catch (error) {
      console.error("Unexpected error:", error);
      setLoading(false);
      setAlertMessage("An unexpected error occurred. Please try again.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle stock loss change submit
  const handleSLChangeSubmit = (e) => {
    e.preventDefault();
    console.log("inside sl handler", newsl);
    console.log("inside sl selected record", selectedRecord);

    // Validation: Check if newsl is provided and is a valid number
    if (!newsl || isNaN(newsl) || parseFloat(newsl) <= 0) {
      setAlertMessage("Please enter a valid Stop Loss value greater than 0.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
      return;
    }

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        throw new Error("User is not logged in. Please log in again.");
      }

      fetch(`${BASE_URL}/editsl?id=${selectedRecord.id}&type=SL&value=${newsl}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
            console.log("SL edit success");
            setSLEditOpen(false);
            updateSLchange();

            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            setLoading(false);
            setAlertMessage(res.message || "Failed to update Stop Loss.");
            setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error during SL update:", error);
          setLoading(false);
          setAlertMessage("An error occurred while updating Stop Loss. Please try again.");
          setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
        });
    } catch (error) {
      console.error("Unexpected error:", error);
      setLoading(false);
      setAlertMessage("An unexpected error occurred. Please try again.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle first target change submit
  const handleFirstTargetChangeSubmit = async (e) => {
    e.preventDefault();
    console.log("inside firstTarget handler", newfirstTarget);
    console.log("inside firstTarget selected record", selectedRecord);

    // Validation: Check if newfirstTarget is provided and is a valid number
    if (!newfirstTarget || isNaN(newfirstTarget) || parseFloat(newfirstTarget) <= 0) {
      setAlertMessage("Please enter a valid First Target value greater than 0.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
      return;
    }

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        throw new Error("User is not logged in. Please log in again.");
      }

      const response = await fetch(`${BASE_URL}/editsl?id=${selectedRecord.id}&type=firstTarget&value=${newfirstTarget}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      });

      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();
      console.log("res", res);

      if (res.success === true) {
        console.log("FirstTarget edit Success");
        setFirstTargetEditOpen(false);
        updateSLchange();
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        throw new Error(res.message || "Failed to update First Target.");
      }
    } catch (error) {
      console.error("Error during First Target update:", error);
      setLoading(false);
      setAlertMessage(error.message || "An unexpected error occurred. Please try again.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle second target change submit
  const handleSecondTargetChangeSubmit = async (e) => {
    e.preventDefault();
    console.log("inside second target handler", newsecondTarget);
    console.log("inside secondTarget selected record", selectedRecord);

    // Validation: Check if newsecondTarget is provided and is a valid number
    if (!newsecondTarget || isNaN(newsecondTarget) || parseFloat(newsecondTarget) <= 0) {
      setAlertMessage("Please enter a valid Second Target value greater than 0.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
      return;
    }

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        throw new Error("User is not logged in. Please log in again.");
      }

      const response = await fetch(`${BASE_URL}/editsl?id=${selectedRecord.id}&type=secondTarget&value=${newsecondTarget}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      });

      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();
      console.log("res", res);

      if (res.success === true) {
        console.log("Second Target edit Success");
        setSecondTargetEditOpen(false);
        updateSLchange();
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        throw new Error(res.message || "Failed to update Second Target.");
      }
    } catch (error) {
      console.error("Error during Second Target update:", error);
      setLoading(false);
      setAlertMessage(error.message || "An unexpected error occurred. Please try again.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle authentication change
  const handleAuthChange = (e) => {
    const { name, value } = e.target;
    setAuthData((prevState) => {
      const newState = {
        ...prevState,
        [name]: value
      };


      return newState;
    });
  };

  // handle book profit or loss submit
  const handleBookProfitOrLoss = async (e, BookPorL) => {
    e.preventDefault();

    try {
      let bodydata = JSON.stringify({
        BookPL: BookPorL,
        IsCommentary: checked,
        CommentryMessage: commentrymessage,
        StockPrice: stockPrice && stockPrice !== "" ? stockPrice : 0,
        FuturePrice: futurePrice && futurePrice !== "" ? futurePrice : 0,
      });

      if (!selectedRecord.id || !cmp) {
        throw new Error("Required data is missing: selectedRecord.id or cmp is not provided.");
      }

      const response = await fetch(
        `${BASE_URL}/bookprofitorcloseposition?id=${selectedRecord.id}&cmpPrice=${cmp}`,
        {
          method: "PUT",
          headers: {
        "Content-Type": "application/json",
          },
          body: bodydata,
        }
      );

      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();

      if (res.success) {
        console.log("Book Profit or Close Position edit Success");
        setOpenDialog(false);
        updateSLchange();
        setCommentryMessage("");
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        throw new Error(res.message || "Failed to process the request.");
      }
    } catch (error) {
      console.error("Error in handleBookProfitOrLoss:", error);
      setLoading(false);
      setAlertMessage(error.message || "Internal Server Error.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 1500);
    }
  };

  // handle stock loss change
  const handleSLChange = (e) => {
    let value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setNewSL(value)
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("SL hold 2point value")
    }
  }
  // handle first target change
  const handleFirstTargetChange = (e) => {
    let value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setNewFirstTarget(value)
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("SL hold 2point value")
    }
  }
  // handle second target change
  const handleSecondTargetChange = (e) => {
    let value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setNewSecondTarget(value)
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("SL hold 2point value")
    }
  }


  // handle calcualte profit or loss for current cmp
  const calCurrComp = (row) => {

    let value
    let percentDifference

    if (row.SignalFinal === 'SELL FUT' || row.SignalFinal === 'SELL NKB') {
      value = row.PriceAtSignal - row.Current_cmp
      value = value.toFixed(2);
      percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
    }
    else {
      value = row.Current_cmp - row.PriceAtSignal
      value = value.toFixed(2);
      percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
    }
    // console.log("value",value)
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {row.Current_cmp === '' ? (
          <span>{row.Current_cmp}</span>
        ) : (
          <div>
            <span>{row.Current_cmp}</span> |
            <div>
              <span>
                {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
            </div>
          </div>
         
        )}
      </div>
    )
  }
  // handle calcualte profit or loss for previous cmp
  const TodayPLComp = (row) => {

    let value
    let percentDifference

    if (row.SignalFinal === 'SELL FUT') {
      value = row.prv_day_close - row.Current_cmp
      value = value.toFixed(2);
      percentDifference = ((value / row.prv_day_close) * 100).toFixed(2);
    }
    else {
      value = row.Current_cmp - row.prv_day_close
      value = value.toFixed(2);
      percentDifference = ((value / row.prv_day_close) * 100).toFixed(2);
    }
    // console.log("value",value)
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {row.prv_day_close === '' ? (
          <span>{row.prv_day_close}</span>
        ) : (
          <div>
            <span>{row.prv_day_close}</span> |
            <div>
              <span>
                {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
            </div>
          </div>
         
        )}
      </div>
    )
  }

  // handle remove row from table Dialog
  const handleremove = (row) => {
    setDelSelectedRecord(row);
    SetRemoveAlert(true);
  }

// handle remove row from table submit
  const handleremoveRow = async () => {
    try {
      SetRemoveAlert(false);
      console.log("DelSelectedRecord:", DelSelectedRecord.id);
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        throw new Error("User is not logged in. Please log in again.");
      }

      let data = JSON.stringify({ tablename: 'Data_feed_nifty_decision', modified_by: loginuser.user_id });
      const response = await fetch(`${BASE_URL}/RemoveRow/${DelSelectedRecord.id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
        body: data,
      });

      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();
      if (res.success === true) {
        updateSLchange();
        setAlertMessage(res.message);
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
      } else {
        throw new Error(res.message || "Failed to remove the row.");
      }
    } catch (error) {
      console.error("Error in handleremoveRow:", error);
      setAlertMessage(error.message || "An unexpected error occurred.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    }
  };

  // for automate script record remove dialog
  const automateHandleremove = (row) => {
    setDelSelectedRecord(row);
    SetAutomateRemoveAlert(true);
  }

  // handle remove row from automate script table submit
  const automateHandleremoveRow = async () => {
    try {
      SetAutomateRemoveAlert(false);
      console.log("DelSelectedRecord:", DelSelectedRecord.id);
      let loginuser = JSON.parse(localStorage.getItem("loginData"));

      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        throw new Error("User is not logged in. Please log in again.");
      }

      let data = JSON.stringify({ tablename: 'AutomateScript', modified_by: loginuser.user_id });
      const response = await fetch(`${BASE_URL}/RemoveRow/${DelSelectedRecord.id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
        body: data,
      });

      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();

      if (res.success === true) {
        updateSLchange();
        setAlertMessage(res.message);
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage('')
        }, 3000);
      } else {
        throw new Error(res.message || "Failed to remove the row.");
      }
    } catch (error) {
      console.error("Error in automateHandleremoveRow:", error);
      setAlertMessage(error.message || "An unexpected error occurred.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    }
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const handleChange = (event) => {
    event.preventDefault();
    console.log("event.target.checked", event.target.checked);
    setChecked(event.target.checked);
  };

  // handle send to telegram for automate script
  const automateSendToTelegram = async () => {
    try {
      setAutomateRemark(false);
      setLoading(true);

      console.log("row of selected record", selectedAutomateRecord);
      const eventDate = new Date();
      const day = eventDate.getDate();
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const month = monthNames[eventDate.getMonth()];
      const year = eventDate.getFullYear();
      const formattedDate = `${day} ${month} ${year}`;

      const loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        throw new Error("User is not logged in. Please log in again.");
      }

      const reportType =
        selectedAutomateRecord.SignalFinal === "BUY PUT"
          ? "optionPut"
          : "optionCall";

      const send_telegram = checked ? "Yes" : "No";

      if (!selectedAutomateRecord || !selectedAutomateRecord.id) {
        throw new Error("Selected automate record is missing or invalid.");
      }

      if (!reportType) {
        throw new Error("Report type is missing.");
      }


      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        throw new Error("User is not logged in or login details are missing.");
      }

      const response = await fetch(`${BASE_URL}/createautomatereport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${loginuser.token}`,
        },
        body: JSON.stringify({
          eventType: "Options",
          ReportName: reportType,
          ReportData: selectedAutomateRecord,
          reportDate: formattedDate,
          createdBy: loginuser.user_id,
          CommentryMessage: commentrymessage || "",
          sendTelegram: send_telegram,
        }),
      });

      if (!response.ok) {
        if (response.status === 403 || response.status === 401) {
          localStorage.clear();
          navigate("/login");
          throw new Error("Session expired. Redirecting to login.");
        }
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();

      if (res.success) {
        console.log("data", res.data);
        setAlertMessage(res.message);
      } else {
        throw new Error(res.message || "Failed to create automate report.");
      }
    } catch (error) {
      console.error("Error in automateSendToTelegram:", error);
      setAlertMessage(error.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
      setAutomateRemark(false);
      updateSLchange();
      setSelectedAutomateRecord("");
      setCommentryMessage("");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    }
  };


  // handle refresh automate script data
  const automateRefresh = async (row) => {
    try {
      setLoading(true);
      console.log("row", row);
      let Expiry = row.Expiry;
      let optionType = row.SignalFinal.split(" ")[1];
      let cmpPrice;
      let inst_token = row.InstrumentToken;
      let stock_name = row.SignalType.split(" ")[0];

      // Get CMP of stock
      const cmpResponse = await fetch(`${BASE_URL}/getcmpprice/${stock_name}/${cmpPrice}/${Expiry}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!cmpResponse.ok) {
        throw new Error(`Failed to fetch CMP price. Status: ${cmpResponse.status}`);
      }

      const cmpData = await cmpResponse.json();

      if (cmpData.success) {
        console.log("CMP data:", cmpData.instruments);
        cmpPrice = cmpData.instruments.last_price;
      } else {
        cmpPrice = '';
        console.warn("CMP fetch unsuccessful:", cmpData.message);
      }

      // Refresh automate data
      const refreshResponse = await fetch(`${BASE_URL}/refreshAutomate`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          expiry: Expiry,
          optionType: optionType,
          cmpPrice: cmpPrice,
          inst_token: inst_token,
          stock_name: stock_name,
          recordId: row.id,
        }),
      });

      if (!refreshResponse.ok) {
        throw new Error(`Failed to refresh automate data. Status: ${refreshResponse.status}`);
      }

      const refreshData = await refreshResponse.json();

      if (refreshData.success) {
        console.log("Updated record:", refreshData.data);
        setRefreshAutomateData(refreshData.data);
        updateSLchange();
        setAlertMessage(refreshData.message);
      } else {
        console.warn("Automate refresh unsuccessful:", refreshData.message);
        setAlertMessage(refreshData.message);
      }
    } catch (error) {
      console.error("Error in automateRefresh:", error);
      setAlertMessage(error.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    }
  };

  // handle automate remark close
  const handleAutomateRemarkClose = async () => {
    setAutomateRemark(false);
    setSelectedAutomateRecord("");
    setCommentryMessage("");
  }

  // handle automate report send diolog open
  const handleAutomateReportSend = async (row) => {
    setSelectedAutomateRecord(row);
    setAutomateRemark(true)
  }

  // handle automate report send diolog close
  const RefreshBOOKPL = async () => {
    try {
      setLoading(true);
      let url;

      if (selectedRecord.SignalFinal === 'BUY CALL IntraDay' || selectedRecord.SignalFinal === 'BUY PUT IntraDay') {
        if (!selectedRecord.InstrumentToken || !selectedRecord.Stock_InsToken || !selectedRecord.future_token) {
          throw new Error("Missing required data for IntraDay CMP fetch.");
        }
        url = `${BASE_URL}/getcmpdashboard/${selectedRecord.InstrumentToken}/${selectedRecord.Stock_InsToken}/${selectedRecord.future_token}`;
      } else {
        if (!selectedRecord.InstrumentToken || !selectedRecord.Stock_InsToken) {
          throw new Error("Missing required data for CMP fetch.");
        }
        url = `${BASE_URL}/getcmpdashboard/${selectedRecord.InstrumentToken}/${selectedRecord.Stock_InsToken}/futureToken`;
      }

      const response = await fetch(url, { method: "GET" });
      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();
      if (res.success) {
        console.log("CMP fetch successful:", res);

        if (selectedRecord.SignalFinal === 'BUY CALL IntraDay' || selectedRecord.SignalFinal === 'BUY PUT IntraDay') {
          setCMP(res.data);
          setStockPrice(res.FuturePrice);
          setFuturePrice(res.StockPrice);
        } else {
          setCMP(res.data);
          setStockPrice(res.StockPrice);
          setFuturePrice(res.FuturePrice);
        }

        let value;
        if (selectedRecord.SignalFinal === 'SELL FUT') {
          value = selectedRecord.PriceAtSignal - res.data;
        } else {
          value = res.data - selectedRecord.PriceAtSignal;
        }
        setBookPorL(value.toFixed(2));
        setOpenDialog(true);
      } else {
        throw new Error("CMP not found. Please try again later.");
      }
    } catch (error) {
      console.error("Error in RefreshBOOKPL:", error);
      setAlertMessage(error.message || "An unexpected error occurred while refreshing CMP.");
    } finally {
      setLoading(false);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      } , 1500);
    }
  };

  // handle profit loss calculation
  const ProfitLossCal =  (row)=>{
    // console.log("profitloss",row)
    let value
    let percentDifference

    if (row.SignalFinal === 'SELL FUT') {
      value = row.PriceAtSignal - row.PriceAtExit
      value = value.toFixed(2);
      percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
    }
    else {
      value = row.PriceAtExit - row.PriceAtSignal
      value = value.toFixed(2);
      percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
    }
    // console.log("value",value)
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {row.PriceAtExit === '' ? (
          <span>{row.PriceAtExit}</span>
        ) : (
          <div>
            <span>{row.PriceAtExit}</span> |
            <div>
              <span>
                {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
            </div>
          </div>
       
        )}
      </div>
    )
  }

  return (
    <div className='screenerTab'>
      <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '5px' }}>
        <h6 style={{ marginRight: '10px' }}>{heading}</h6>

        <span style={{
          textAlign: 'center',
          cursor: 'pointer',
          color: '#fff',
          width: '50px',
          height: '31px',
          fontSize: '10px',
          marginTop: '7px',
          backgroundColor: 'rgb(35, 73, 158)',
          border: '2px solid rgb(35, 73, 158)',
          borderRadius: '10px'
        }} onClick={updateSLchange}><Tooltip title={"Refresh Data"} placement="right">
            <RefreshIcon sx={{ width: 20, height: 20, color: '#FFF', marginTop: '3px' }} />
          </Tooltip></span>
      </div>
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}

        >
          <Loading />
        </div>
      ) : null}

      {heading === 'Screener Tab' || heading === 'IntraDay Tab' ? (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
              <TableHead >

                <TableRow>
                  {Intradaycolumns.map((column, index) => (

                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        textAlign: 'center',
                        minWidth: column.minWidth,
                        backgroundColor: '#23499E',
                        color: 'white',
                        zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 20 : 5,
                        left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined

                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}


                </TableRow>
              </TableHead>
              <TableBody>
                {Record
                  .slice(startIndex, endIndex)
                  .map((row, index) => {
                    const isNewRecord = newRecords.some(newRecord => newRecord.id === row.id);
                    // console.log("isNewRecord",isNewRecord)
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {Intradaycolumns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              style={{
                                position: 'sticky',
                                backgroundColor: RecordColor == 1 ? '#fff' : isNewRecord ? 'lightgreen' : '#fff',
                                zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 10 : 1,
                                left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined
                              }}
                              class="table-cell-screenerTab"
                              key={column.id}
                              align={column.align}
                            >
                              {column.id === "S.No"
                                ? index + 1
                                : column.id === 'SignalType'
                                  ? <div style={{ color: 'blue', fontWeight: '600', cursor: 'pointer' }} onClick={() => hyperLinkStockName(row)}>
                                    {value}
                                  </div>
                                  : column.id === 'SignalStopLoss'
                                    ? <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleStockLossChange(row)}>
                                      {value}
                                    </div>
                                  : column.id === 'FirstTarget'
                                    ? <div style={{ textAlign: 'right',color:'blue' }} >
                                      {value}
                                      {console.log("value",value)}
                                  <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => handleFirstTargetChangelink(row)}>
                                    <Tooltip title={value === '' || value === null ? "Enter First Target" : "Edit First Target"} placement="right">
                                      {value === '' || value === null? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                    </Tooltip>
                                  </span>
                                    </div>
                                  : column.id === 'SecondTarget'
                                    ? <div style={{textAlign: 'right',color:'blue' }} >
                                      {value}
                                      <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => handleSecondTargetChangelink(row)}>
                                    <Tooltip title={value === '' || value === null ? "Enter First Target" : "Edit First Target"} placement="right">
                                      {value === '' || value === null? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                    </Tooltip>
                                  </span>
                                    </div>
                                    : column.id === "datetime"
                                      ? formatDateTime(row)
                                      : column.id === "Expiry"
                                        ? formatExpiry(row)
                                        : column.id === "Current_cmp"
                                          ? calCurrComp(row)
                                        : column.id === "prv_day_close"
                                          ? TodayPLComp(row)
                                          : column.id === 'Remove'
                                            ? <div>
                                              <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }}
                                                onClick={() => handleremove(row)}
                                              >
                                                <Tooltip title={"Remove row"} placement="right">
                                                  <HighlightOffIcon sx={{ width: 20, height: 20 }} />
                                                </Tooltip>
                                              </span>
                                            </div> : value
                              }
                            </TableCell>
                          );
                        })}

                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            component="div"
            count={Record.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
              <TableHead >

                <TableRow>
                  {columns.map((column, index) => {
                      if (column.id === "Margin" && heading !== "Future Tab") {
                        return null;
                      }
                      if (column.id === "OptionAtMoney" && heading === "Future Tab") {
                        return null;
                      }
          
                  return(
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        textAlign: 'center',
                        minWidth: column.minWidth,
                        backgroundColor: '#23499E',
                        color: 'white',
                        zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 20 : 5,
                        left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined

                      }}
                    >
                      {column.label}
                    </TableCell>
                  );
               })}


                </TableRow>
              </TableHead>
              <TableBody>
                {Record
                  .slice(startIndex, endIndex)
                  .map((row, index) => {
                    const isNewRecord = newRecords.some(newRecord => newRecord.id === row.id);
                    // console.log("isNewRecord",isNewRecord)
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          if (column.id === "Margin" && heading !== "Future Tab") {
                            return null;
                          }
                          if (column.id === "OptionAtMoney" && heading === "Future Tab") {
                            return null;
                          }
                          return (
                            <TableCell
                              style={{
                                position: 'sticky',
                                backgroundColor: RecordColor == 1 ? '#fff' : isNewRecord ? 'lightgreen' : '#fff',
                                zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 10 : 1,
                                left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined
                              }}
                              class="table-cell-screenerTab"
                              key={column.id}
                              align={column.align}
                            >
                              {column.id === "S.No"
                                ? index + 1
                                : column.id === 'SignalType'
                                  ? <div style={{ color: 'blue', fontWeight: '600', cursor: 'pointer' }} onClick={() => hyperLinkStockName(row)}>
                                    {value}
                                  </div>
                                  : column.id === 'SignalStopLoss'
                                    ? <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleStockLossChange(row)}>
                                      {value}
                                    </div>
                                    
                                    : column.id === 'FirstTarget'
                                    ? <div style={{ textAlign: 'right',color:'blue' }} >
                                      {value}
                                      {console.log("value",value)}
                                  <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => handleFirstTargetChangelink(row)}>
                                    <Tooltip title={value === '' || value === null ? "Enter First Target" : "Edit First Target"} placement="right">
                                      {value === '' || value === null? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                    </Tooltip>
                                  </span>
                                    </div>
                                  : column.id === 'SecondTarget'
                                    ? <div style={{textAlign: 'right',color:'blue' }} >
                                      {value}
                                      <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => handleSecondTargetChangelink(row)}>
                                    <Tooltip title={value === '' || value === null ? "Enter First Target" : "Edit First Target"} placement="right">
                                      {value === '' || value === null? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                    </Tooltip>
                                  </span>
                                    </div>
                                    : column.id === "datetime"
                                      ? formatDateTime(row)
                                      : column.id === "Expiry"
                                        ? formatExpiry(row)
                                        : column.id === "Current_cmp"
                                          ? calCurrComp(row)
                                          : column.id === "prv_day_close"
                                          ? TodayPLComp(row)
                                          : column.id === 'Remove'
                                            ? <div>
                                              <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }}
                                                onClick={() => handleremove(row)}
                                              >
                                                <Tooltip title={"Remove row"} placement="right">
                                                  <HighlightOffIcon sx={{ width: 20, height: 20 }} />
                                                </Tooltip>
                                              </span>
                                            </div> : value
                              }
                            </TableCell>
                          );
                        })}

                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            component="div"
            count={Record.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}





      {/* Automate Generated Signals script data */}
      {heading === 'Option Tab' && (
        <>
          <h6>Automatic Generated Signals</h6>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
                <TableHead >
                  <TableRow>
                    {Scriptcolumns.map((column, index) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          textAlign: 'center',
                          minWidth: column.minWidth,
                          backgroundColor: '#23499E',
                          color: 'white',
                          zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 20 : 5,
                          left: column.id === "S.No" ? 120 : column.id === "SignalType" ? 160 : column.id === "Remove" ? 0 : undefined

                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {AutomateRecord
                    .slice(startIndex, endIndex)
                    .map((row, index) => {
                      const isNewRecord = AutomatenewRecords.some(newRecord => newRecord.id === row.id);
                      // console.log("isNewRecord",isNewRecord)
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                          {Scriptcolumns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                style={{
                                  position: 'sticky',
                                  backgroundColor: RecordColor === 1 ? '#fff' : isNewRecord ? 'lightgreen' : '#fff',
                                  zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 10 : 1,
                                  left: column.id === "S.No" ? 120 : column.id === "SignalType" ? 160 : column.id === "Remove" ? 0 : undefined
                                }}
                                class="table-cell-screenerTab"
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "S.No"
                                  ? index + 1
                                  : column.id === 'SignalType'
                                    ? <div style={{ color: 'blue', fontWeight: '600', cursor: 'pointer' }} >
                                      {value}
                                    </div>
                                    : column.id === 'SignalStopLoss'
                                      ? <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleStockLossChange(row)}>
                                        {value}
                                      </div>
                                      : column.id === "datetime"
                                        ? formatDateTime(row)
                                        : column.id === "Expiry"
                                          ? formatExpiry(row)
                                          : column.id === "Current_cmp"
                                            ? calCurrComp(row)
                                            : column.id === 'Remove'
                                              ? <div style={{ display: 'flex', justifyContent: 'space-around', flexDirection: 'row' }}>
                                                <span style={{ fontSize: '24px', color: '#454545', cursor: 'pointer' }} aria-label="Remove"
                                                  onClick={() => automateHandleremove(row)}
                                                >
                                                  <Tooltip title={"Remove row"} placement="right">
                                                    <HighlightOffIcon sx={{ width: 20, height: 20 }} />
                                                  </Tooltip>
                                                </span>
                                                <span style={{ fontSize: '24px', cursor: 'pointer' }} aria-label="refresh" onClick={() => automateRefresh(row)}>
                                                  <Tooltip title={"Refresh Data"} placement="right">
                                                    <RefreshIcon sx={{ width: 20, height: 20, color: '#23499E' }} />
                                                  </Tooltip>
                                                </span>
                                                <span style={{ fontSize: '24px', cursor: row.send_telegram === 1 ? 'not-allowed' : 'pointer' }} aria-label="send" onClick={() => row.send_telegram === 1 ? null : handleAutomateReportSend(row)}>
                                                  <Tooltip title={"Send To Telegram"} placement="right">
                                                    <SendIcon sx={{ width: 20, height: 20, color: row.send_telegram === 1 ? 'grey' : '#23499E' }} />
                                                  </Tooltip>
                                                </span>
                                              </div>

                                              : value
                                }
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[25, 50, 75, 100]}
              component="div"
              count={AutomateRecord.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </>
      )
      }



      <>
        <h6>Previous 7 Day Close Signals</h6>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
              <TableHead >
                <TableRow>
                  {PreviousColumns.map((column, index) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        textAlign: 'center',
                        minWidth: column.minWidth,
                        backgroundColor: '#23499E',
                        color: 'white',
                        zIndex: column.id === "S.No" || column.id === "Action" || column.id === "SignalType" ? 20 : 5,
                        left: column.id === "S.No" ? 0 :  column.id === "Action"? 40 : column.id === "SignalType" ? 110  : undefined

                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {PreviousRecord
                  .slice(startIndex, endIndex)
                  .map((row, index) => {
                    const isNewRecord = AutomatenewRecords.some(newRecord => newRecord.id === row.id);
                    // console.log("isNewRecord",isNewRecord)
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {PreviousColumns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              style={{
                                position: 'sticky',
                                backgroundColor: RecordColor == 1 ? '#fff' : isNewRecord ? 'lightgreen' : '#fff',
                                zIndex: column.id === "S.No" || column.id === "Action" || column.id === "SignalType"  ? 10 : 1,
                                left: column.id === "S.No" ? 0 : column.id === "Action" ? 40 : column.id === "SignalType" ? 110 : undefined
                              }}
                              class="table-cell-screenerTab"
                              key={column.id}
                              align={column.align}
                            >
                              {column.id === "S.No"
                                ? index + 1
                                
                                    : column.id === "datetime"
                                    ? formatDateTime(row)
                                    : column.id === "Action"
                                    ? ActionDiv(row)
                                    : column.id === "ExitDt"
                                      ? formatExitDt(row)
                                      : column.id === "Expiry"
                                        ? formatExpiry(row)
                                        : column.id === "PriceAtExit"
                                          ? ProfitLossCal(row)
                                            : value
                              }
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            component="div"
            count={PreviousRecord.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </>



      {/* dialog for book profit and book loss */}
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {BookPorL >= 0 ? 'Book Profit' : 'Book Loss'}
        </DialogTitle>
        <DialogContent className='dialog-content' >
          <div className="Authmain">
            <div className="Authcontent">
              <div style={{ textAlign: 'center' }}>
                <span style={{ cursor: 'pointer', color: '#23499E' }} onClick={RefreshBOOKPL}><Tooltip title={"Refresh Data"} placement="right">
                  <RefreshIcon sx={{ width: 20, height: 20, color: '#23499E' }} />
                </Tooltip>Refresh</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                  <div>
                    <h4 style={{ display: 'inline' }}>{selectedRecord.SignalFinal === 'BUY CALL IntraDay' || selectedRecord.SignalFinal === 'BUY PUT IntraDay' || selectedRecord.SignalFinal === 'BUY CALL' || selectedRecord.SignalFinal === 'BUY PUT' ? 'Option CMP:' : 'CMP:'}</h4>
                    <div className='cmp-value'>
                      <span>{selectedRecord.SignalFinal === 'BUY FUT' || selectedRecord.SignalFinal === 'SELL FUT' ?stockPrice:cmp} {BookPorL >= 0 ? <ArrowDropUpIcon fontSize="large" color="success" /> : <ArrowDropDownIcon fontSize="large" sx={{ color: 'red' }} />}</span>
                      <span style={{ color: BookPorL >= 0 ? 'green' : 'red' }}>{BookPorL}</span>
                    </div>
                  </div>
                  {selectedRecord.SignalFinal === 'BUY FUT' || selectedRecord.SignalFinal === 'SELL FUT' ? (<div>
                    <h4 style={{ display: 'inline' }}>Future CMP:</h4>
                    <div className='cmp-value'>
                      <span>{cmp}</span>
                    </div>
                  </div>) : null}
                  {selectedRecord.SignalFinal === 'BUY CALL' || selectedRecord.SignalFinal === 'BUY PUT' ? (<div>
                    <h4 style={{ display: 'inline' }}>Cash CMP:</h4>
                    <div className='cmp-value'>
                      <span>{stockPrice}</span>
                    </div>
                  </div>) : null}
                  {selectedRecord.SignalFinal === 'BUY CALL IntraDay' || selectedRecord.SignalFinal === 'BUY PUT IntraDay' ? (<div>
                    <h4 style={{ display: 'inline' }}>Cash CMP:</h4>
                    <div className='cmp-value'>
                      <span>{stockPrice}</span>
                    </div>
                  </div>) : null}

                  
                </div>

                <div style={{ width: '100%' }}>
                  <label htmlFor="withCommentery" style={{ marginRight: '10px' }}>With Commentary</label>
                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                  <label htmlFor="Commentry" style={{ marginRight: '10px' }}>Commentary</label>
                  <textarea
                    id="inputField"
                    style={{ border: '2px solid #000' }}
                    placeholder="Type a message"
                    value={commentrymessage}
                    onChange={(e) => setCommentryMessage(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={(e) => handleBookProfitOrLoss(e, BookPorL >= 0 ? 'Book Profit' : 'Close Position')}>
            {BookPorL >= 0 ? 'Book Profit' : 'Close Position'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* dialog for authencation */}
      <Dialog
        open={authenticationOpen}
        onClose={handleAuthenticationClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Authentication to change SL"}
         
        </DialogTitle>
        {loading ? (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}

          >
            <Loading />
          </div>
        ) : null}
        <form onSubmit={handleAuthSubmit}>
          <DialogContent className='dialog-content'>
            <div className="Authmain">
              <div className="Authcontent">
                {Errorshow ?
                  <span style={{ color: "red" }}>
                    {Errormessage}
                  </span>
                  : null}
                <div>
                  <p>Username :<span className='asterisk'>*</span></p>
                  <input value={authdata.username} type="email" id="username" name="username" required onChange={handleAuthChange} autocomplete="off" placeholder="Enter username" />
                </div>

                {showInvalidPasswordAlert && (
                  <span>
                    Please enter a valid password. Passwords must be at least 8
                    characters long and contain at least one letter, one digit, and
                    may include special characters.
                  </span>
                )}
                <div>
                  <p>Password :<span className='asterisk'>*</span></p>
                  <input value={authdata.password} type="password" id="password" name="password" required onChange={handleAuthChange} autocomplete="off" placeholder="Enter Password" />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button className='btn-cancel' onClick={handleAuthenticationClose}>Cancel</Button>

            <input type="submit" value="Submit" className='btn-submit'
              style={{ width: '70px', borderRadius: '5px', cursor: authdata.username === '' || authdata.password === '' ? 'not-allowed' : 'pointer' }}
              disabled={authdata.username === '' || authdata.password === ''} />
          </DialogActions>
        </form>
      </Dialog>

      {/* dialog for sl change  */}

      <Dialog
        open={SLEditOpen}
        onClose={handleSLEditClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter New Stop Loss"}
        </DialogTitle>
        <DialogContent className='dialog-content'>
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

          <div className="Authmain">
            <div className="Authcontent">
              {Errorshow ?
                <span style={{ color: "red" }}>
                  {Errormessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Stop Loss:<span className='asterisk'>*</span></p>
                <input value={newsl} type="number" id="sl" name="sl" required onChange={handleSLChange} />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={handleSLEditClose}>cancel</Button>
          <Button className='btn-yes' onClick={handleSLChangeSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>


         {/* dialog for first Target change  */}

         <Dialog
        open={FirstTargetEditOpen}
        onClose={handleFirstTargetEditClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter New First Target"}
        </DialogTitle>
        <DialogContent className='dialog-content' >
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

          <div className="Authmain">
            <div className="Authcontent">
              {Errorshow ?
                <span style={{ color: "red" }}>
                  {Errormessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>First Target:<span className='asterisk'>*</span></p>
                <input value={newfirstTarget} type="number" id="firstTarget" name="firstTarget" required onChange={handleFirstTargetChange} />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={handleFirstTargetEditClose}>cancel</Button>
          <Button className='btn-yes' onClick={handleFirstTargetChangeSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
         </Dialog>

         {/* dialog for second change  */}

         <Dialog
        open={SecondTargetEditOpen}
        onClose={handleSecondTargetEditClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter New Second Target"}
        </DialogTitle>
        <DialogContent className='dialog-content' >
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

          <div className="Authmain">
            <div className="Authcontent">
              {Errorshow ?
                <span style={{ color: "red" }}>
                  {Errormessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Second Target:<span className='asterisk'>*</span></p>
                <input value={newsecondTarget} type="number" id="secondTarget" name="secondTarget" required onChange={handleSecondTargetChange} />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={handleSecondTargetEditClose}>cancel</Button>
          <Button className='btn-yes' onClick={handleSecondTargetChangeSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={RemoveAlert}
        onClose={() => SetRemoveAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
          {"Confirmation "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to remove row
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={() => SetRemoveAlert(false)}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={handleremoveRow}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>


      {/* automate remove row dialog */}

      <Dialog
        open={AutomateRemoveAlert}
        onClose={() => SetAutomateRemoveAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
          {"Confirmation "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to remove row
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={() => SetAutomateRemoveAlert(false)}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={automateHandleremoveRow}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* dialog for error show */}

      <Dialog
        open={automateRemark}
        onClose={handleAutomateRemarkClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter Report Remark"}
        </DialogTitle>
        <DialogContent>
        <div style={{ width: '100%' }}>
                  <label htmlFor="withCommentery" style={{ marginRight: '10px' }}>Send Telegram</label>
                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
        </div>
          <div style={{ width: '100%' }}>
            <label htmlFor="Commentry" style={{ marginRight: '10px' }}>Commentary</label>
            <textarea
          
              id="AutomateinputField"
              placeholder="Type a message"
              value={commentrymessage}
              onChange={(e) => setCommentryMessage(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={handleAutomateRemarkClose}
          >
            Close
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={automateSendToTelegram}
            autoFocus
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={showAlert}
        onClose={() => { setshowAlert(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
      </Dialog>



      {/* Dailog for message send in telegram */}

      <Dialog
        class="SLFirstMessage"
        open={MessageSLandFirstTraget}
        onClose={handleSLandFirstTragetClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Send Message"}
        </DialogTitle>
        <DialogContent>
          <div style={{ width: '350px' }}>
            <label htmlFor="Commentry" style={{ marginRight: '10px' }}>Message</label>
            <textarea
              style={{height:'150px',width:'100%',border:'1px solid black',margin:'0px'}}
              id="inputField"
              placeholder="Type a message"
              value={SlandFirstTargetmsg}
              onChange={(e) => setSlandFirstTargetmsg(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={handleSLandFirstTragetClose}
          >
            Close
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={SLandFirstSendToTelegram}
            autoFocus
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ScreenerTab
